import ModalDeleteFilled from '../../../../../../../../baseComponents/ModalsLayouts/ModalDeleteFilled'
import { ModalComponentProps } from '../../../../../../../../baseComponents/ModalsLayouts/types'
import { useFetchText } from '../../../../../../../../utils/hooks/useFetchText'
import useTwinTranslation from '../../../../../../../../utils/hooks/useTwinTranslation'

interface ModalDeleteWCFreeDaysProps extends ModalComponentProps {
    id?: number
}

const ModalDeleteWCFreeDays: React.FC<ModalDeleteWCFreeDaysProps> = ({ setOpened, onSubmit, id }) => {
    const { t } = useTwinTranslation()
    const { handleFetchText } = useFetchText({
        onSubmit,
        url: '/api/app/workingCalendar/workingCalendarFree/deleteWorkingCalendarFreeDay',
        data: {
            id
        }
    })
    return (
        <ModalDeleteFilled opened={true} setOpened={setOpened} onCancel={() => setOpened(null)} onAccept={handleFetchText} translations={{
            title: t('sureDeleteWorkingCalendarFreeDays', '¿Seguro quieres eliminar este día festivo?'),
            subtitle: t('onceDeletedNotRecoverM', 'Una vez eliminado no podrás recuperarlo')
        }} />
    )
}

export default ModalDeleteWCFreeDays
